export default __webpack_public_path__ + "static/media/icn_hamburger_v2_2.41e7b01b.svg";